import template from './appointment_filter_modal.html';

angular.module('bb.listing_search').component('bbAppointmentFilterModal', {
  bindings: {},
  controller: AppointmentFilterModalController,
  controllerAs: 'vm',
  template,
});

AppointmentFilterModalController.$inject = [
  '$rootScope',
  'ListingSearchService',
  'ModalService',
];
function AppointmentFilterModalController(
  $rootScope,
  ListingSearchService,
  ModalService,
) {
  const vm = this;
  vm.appointmentFilterModal = ModalService.appointmentFilterModal;

  vm.teams = [];
  vm.displayTeamFilter = false;

  const fetchTeamData = async teamIds => {
    try {
      vm.teams = await ListingSearchService.getTeamsByIds(teamIds);
    } catch (error) {
      console.error('Error fetching team data:', error);
    }
  };

  /**
   * although this is watching labelOverrideMap
   * we're actually watching auth.
   * watching auth directly seems to not be working
   * properly
   */
  $rootScope.$watch('labelOverrideMap', async () => {
    const { auth } = $rootScope || {};
    if (!auth) return;

    vm.teams = auth.teams || [];
    if (vm.teams.length > 1) {
      vm.displayTeamFilter = true;
      fetchTeamData(vm.teams);
      return;
    }
    vm.displayTeamFilter = false;
  });

  vm.statuses = [
    { label: 'Pending', status: 'pending' },
    { label: 'New', status: 'new' },
    { label: 'Attempted', status: 'attempted' },
    { label: 'Confirmed', status: 'confirm' },
    { label: 'Deny', status: 'deny' },
    { label: 'Cancel', status: 'cancel' },
    { label: 'Time Change', status: 'time_change' },
    { label: 'Time Passed', status: 'time_passed' },
  ];

  vm.selectAllStatuses = () => {
    vm.statuses.forEach(status => {
      vm.appointmentFilterModal.preferences.statuses[status.status] = true;
    });
  };

  vm.deselectAllStatuses = () => {
    vm.statuses.forEach(status => {
      vm.appointmentFilterModal.preferences.statuses[status.status] = false;
    });
  };

  vm.savePreferences = () => {
    if (
      vm.dateForm.dateFrom.$error.format ||
      vm.dateForm.dateTo.$error.format ||
      vm.dateForm.dateFrom.$error.range ||
      vm.dateForm.dateTo.$error.range
    )
      return;

    ModalService.closeAppointmentFilterModal(
      vm.appointmentFilterModal.preferences,
      true,
    );
  };

  vm.checkDateRange = () => {
    if (
      !vm.appointmentFilterModal.preferences.dateFrom ||
      !vm.appointmentFilterModal.preferences.dateTo ||
      vm.appointmentFilterModal.preferences.dateFrom <=
        vm.appointmentFilterModal.preferences.dateTo
    )
      return true;
    return false;
  };

  vm.checkDate = (date, label) => {
    if (date && moment(date.toISOString(), moment.ISO_8601).isValid()) {
      vm.dateForm[label].$error.format = false;
    } else {
      vm.dateForm[label].$error.format = true;
    }
    if (vm.checkDateRange()) {
      vm.dateForm.dateFrom.$error.range = false;
      vm.dateForm.dateTo.$error.range = false;
    } else {
      vm.dateForm[label].$error.range = true;
    }
  };

  vm.cancelFilter = () => {
    vm.dateForm.dateFrom.$error.format = false;
    vm.dateForm.dateTo.$error.format = false;
    ModalService.closeAppointmentFilterModal(null, false); // data-dismiss="modal"
  };
}
